const CURRENCIES = {
  default: 'EUR',
};

export default CURRENCIES;
